// Aviso "Adicionado ao carrinho" (v181): a foto do produto "voa" até o ícone do carrinho,
// o ícone dá um pulinho e aparece um aviso discreto com foto, nome, tensão/quantidade e
// o botão "Ver carrinho". Usado pelo card (botão Adicionar e balão "Escolha a tensão")
// e pela tela de detalhes. Não depende de bibliotecas; respeita "reduzir movimento".
let caixa = null;
let timer = null;

function css() {
  if (document.getElementById("mx3-addcart-css")) return;
  const s = document.createElement("style");
  s.id = "mx3-addcart-css";
  s.textContent = `
.mx3-fly{position:fixed;z-index:2147483000;pointer-events:none;border-radius:12px;object-fit:contain;background:#fff;
 box-shadow:0 10px 30px rgba(0,0,0,.25);will-change:transform,opacity;transform-origin:center center;border:2px solid var(--mx3-style-primary,#ff6600)}
@keyframes mx3CartBump{0%{transform:scale(1)}30%{transform:scale(1.3) rotate(-8deg)}60%{transform:scale(.92) rotate(4deg)}100%{transform:scale(1)}}
.mx3-cart-bump{animation:mx3CartBump .55s ease}
.mx3-addcart{position:fixed;right:20px;top:84px;z-index:100001;width:340px;max-width:calc(100vw - 24px);
 background:#fff;color:#1f2328;border-radius:14px;box-shadow:0 18px 48px rgba(0,0,0,.22);overflow:hidden;
 font-family:inherit;transform:translateY(-14px) scale(.97);opacity:0;transition:transform .3s ease,opacity .3s ease}
.mx3-addcart.on{transform:none;opacity:1}
.mx3-addcart-top{display:flex;align-items:center;gap:8px;padding:10px 14px;font-weight:700;font-size:14px;color:#14804a;background:#eafaf1}
.mx3-addcart-ok{width:22px;height:22px;border-radius:50%;background:#16a34a;color:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.mx3-addcart-ok svg{stroke-dasharray:24;stroke-dashoffset:24;animation:mx3Check .45s .15s ease forwards}
@keyframes mx3Check{to{stroke-dashoffset:0}}
.mx3-addcart-x{margin-left:auto;background:none;border:0;font-size:20px;line-height:1;color:#6b7280;cursor:pointer;padding:0 2px}
.mx3-addcart-body{display:flex;gap:12px;padding:12px 14px;align-items:center}
.mx3-addcart-body img{width:58px;height:58px;object-fit:contain;border-radius:8px;background:#f6f7f9;flex-shrink:0}
.mx3-addcart-nome{font-size:13px;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.mx3-addcart-info{font-size:12px;color:#6b7280;margin-top:3px}
.mx3-addcart-acts{display:flex;gap:8px;padding:0 14px 14px}
.mx3-addcart-acts button{flex:1;border-radius:8px;padding:8px 10px;font-size:13px;font-weight:600;cursor:pointer;border:1px solid #d1d5db;background:#fff;color:#374151}
.mx3-addcart-acts .mx3-addcart-ver{border:0;color:#fff;background:linear-gradient(135deg,var(--mx3-style-primary,#ff6600) 0,var(--mx3-style-primary-dark,#cc5200) 100%)}
.mx3-addcart-bar{height:3px;background:var(--mx3-style-primary,#ff6600);transform-origin:left;animation:mx3Bar linear forwards}
.mx3-addcart:hover .mx3-addcart-bar{animation-play-state:paused}
@keyframes mx3Bar{from{transform:scaleX(1)}to{transform:scaleX(0)}}
@media (max-width:768px){.mx3-addcart{left:12px;right:12px;top:auto;bottom:16px;width:auto;transform:translateY(20px)}.mx3-addcart.on{transform:none}}
@media (prefers-reduced-motion:reduce){.mx3-addcart{transition:none}}`;
  document.head.appendChild(s);
}

function visivel(el) {
  if (!el || !el.getBoundingClientRect) return null;
  const r = el.getBoundingClientRect();
  if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth) return r;
  return null;
}

function iconeCarrinho() {
  const lista = document.querySelectorAll(".lucide-shopping-cart");
  for (const el of lista) {
    const btn = el.closest("button") || el;
    if (btn.closest(".produto-card-custom, .mx3-addcart, .product-card, .product-item")) continue;
    if (visivel(btn)) return btn;
  }
  return null;
}

// v183: a animação usa a Web Animations API (element.animate) com trajetória em arco, em vez de
// transição CSS disparada por requestAnimationFrame. Em vários notebooks o Windows está com
// "Efeitos de animação" desligados (economia de bateria / desempenho), o que faz o navegador
// informar "reduzir movimento"; antes isso escondia a foto voando. Agora o efeito sempre roda
// (mais curto quando "reduzir movimento" está ativo) e, se o ícone do carrinho não estiver
// visível, a foto voa para o canto superior direito da tela.
function origemFoto(imgEl) {
  let r = visivel(imgEl);
  if (r) return r;
  const card = imgEl && imgEl.closest && imgEl.closest(".product-image, .produto-card-custom, .product-card");
  return visivel(card);
}

function voar(imgEl, alvo, reduz) {
  try {
    if (!imgEl || !document.body) return Promise.resolve();
    const a = origemFoto(imgEl);
    if (!a) return Promise.resolve();
    const b = visivel(alvo) || { left: window.innerWidth - 70, top: 20, width: 40, height: 40 };
    const lado = Math.min(130, Math.max(70, a.width * 0.55));
    const x0 = a.left + a.width / 2 - lado / 2, y0 = a.top + a.height / 2 - lado / 2;
    const src = imgEl.currentSrc || imgEl.src || "";
    if (!src) return Promise.resolve();
    const clone = document.createElement("img");
    clone.src = src;
    clone.alt = "";
    clone.className = "mx3-fly";
    clone.setAttribute("aria-hidden", "true");
    Object.assign(clone.style, {
      left: x0 + "px", top: y0 + "px", width: lado + "px", height: lado + "px",
      maxWidth: "none", maxHeight: "none", margin: "0", display: "block", opacity: "1"
    });
    document.body.appendChild(clone);
    const dx = b.left + b.width / 2 - (x0 + lado / 2), dy = b.top + b.height / 2 - (y0 + lado / 2);
    const dur = reduz ? 450 : 850;
    const pico = Math.min(-60, dy * 0.25 - 80); // sobe um pouco antes de descer até o carrinho
    const fimBump = () => {
      if (!alvo) return;
      alvo.classList.remove("mx3-cart-bump");
      void alvo.offsetWidth;
      alvo.classList.add("mx3-cart-bump");
      setTimeout(() => alvo.classList.remove("mx3-cart-bump"), 600);
    };
    return new Promise((res) => {
      let feito = false;
      const terminar = () => {
        if (feito) return;
        feito = true;
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        fimBump();
        res();
      };
      if (typeof clone.animate === "function") {
        const anim = clone.animate([
          { transform: "translate(0px, 0px) scale(1)", opacity: 1, offset: 0 },
          { transform: `translate(${dx * 0.45}px, ${dy * 0.45 + pico}px) scale(.75)`, opacity: 1, offset: 0.45 },
          { transform: `translate(${dx}px, ${dy}px) scale(.18)`, opacity: 0.45, offset: 1 }
        ], { duration: dur, easing: "cubic-bezier(.45,.05,.55,.95)", fill: "forwards" });
        anim.onfinish = terminar;
        anim.oncancel = terminar;
      } else {
        clone.style.transition = `transform ${dur}ms ease-in-out, opacity ${dur}ms ease-in-out`;
        void clone.offsetWidth;
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(.18)`;
        clone.style.opacity = ".45";
      }
      setTimeout(terminar, dur + 150); // garantia caso o navegador não dispare onfinish
    });
  } catch (e) {
    return Promise.resolve();
  }
}

function fechar() {
  if (timer) { clearTimeout(timer); timer = null; }
  if (!caixa) return;
  const c = caixa; caixa = null;
  c.classList.remove("on");
  setTimeout(() => c.remove(), 320);
}

function esc(t) {
  const d = document.createElement("div");
  d.textContent = t == null ? "" : String(t);
  return d.innerHTML;
}

function mostrarAviso({ nome, imagem, tensao, qtd, router }) {
  fechar();
  const DUR = 4500;
  const c = document.createElement("div");
  c.className = "mx3-addcart";
  c.setAttribute("role", "status");
  c.setAttribute("aria-live", "polite");
  const info = [tensao ? "Tensão: " + tensao : "", qtd > 0 ? "Quantidade: " + qtd : ""].filter(Boolean).join(" · ");
  c.innerHTML = `
  <div class="mx3-addcart-top"><span class="mx3-addcart-ok"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg></span>
   Produto adicionado ao carrinho<button type="button" class="mx3-addcart-x" aria-label="Fechar">&times;</button></div>
  <div class="mx3-addcart-body">${imagem ? `<img src="${esc(imagem)}" alt="">` : ""}<div><div class="mx3-addcart-nome">${esc(nome)}</div>${info ? `<div class="mx3-addcart-info">${esc(info)}</div>` : ""}</div></div>
  <div class="mx3-addcart-acts"><button type="button" class="mx3-addcart-cont">Continuar comprando</button><button type="button" class="mx3-addcart-ver">Ver carrinho</button></div>
  <div class="mx3-addcart-bar" style="animation-duration:${DUR}ms"></div>`;
  document.body.appendChild(c);
  caixa = c;
  c.querySelector(".mx3-addcart-x").onclick = fechar;
  c.querySelector(".mx3-addcart-cont").onclick = fechar;
  c.querySelector(".mx3-addcart-ver").onclick = () => { fechar(); if (router) router.push("/cart").catch(() => {}); else window.location.href = "/cart"; };
  // Mouse sobre o aviso: não fecha; ao sair, a contagem recomeça.
  const agendar = () => { if (timer) clearTimeout(timer); timer = setTimeout(fechar, DUR); };
  c.addEventListener("mouseenter", () => { if (timer) { clearTimeout(timer); timer = null; } const bar = c.querySelector(".mx3-addcart-bar"); bar.style.animation = "none"; });
  c.addEventListener("mouseleave", () => { const bar = c.querySelector(".mx3-addcart-bar"); bar.style.animation = ""; agendar(); });
  requestAnimationFrame(() => requestAnimationFrame(() => c.classList.add("on")));
  agendar();
}

export function avisarAdicionadoAoCarrinho(opts = {}) {
  if (typeof document === "undefined") return;
  if (document.documentElement.classList.contains("mx3-edit-active")) return;
  css();
  const imgEl = opts.imgEl || null;
  const imagem = opts.imagem || (imgEl && (imgEl.currentSrc || imgEl.src)) || "";
  const reduz = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const alvo = iconeCarrinho();
  const fim = () => mostrarAviso({ ...opts, imagem });
  if (!imgEl) { fim(); return; }
  // O aviso aparece enquanto a foto chega ao carrinho.
  voar(imgEl, alvo, reduz);
  setTimeout(fim, reduz ? 300 : 650);
}
